/**
 * WRT Buyer service for managing buyer groups and their client associations
 */

import { apiClient } from './apiClient';

/**
 * Get all WRT buyers
 */
export const getWRTBuyers = async () => {
  try {
    const response = await apiClient.get(`/api/v1/wrt-buyers`);
    return response.data.data || [];
  } catch (error) {
    console.error('Failed to fetch WRT buyers:', error);
    return [];
  }
};

/**
 * Get single WRT buyer by ID
 */
export const getWRTBuyerById = async (id) => {
  try {
    const response = await apiClient.get(`/api/v1/wrt-buyers/${id}`);
    return response.data.data || null;
  } catch (error) {
    console.error('Failed to fetch WRT buyer:', error);
    return null;
  }
};

/**
 * Create WRT buyer
 */
export const createWRTBuyer = async (buyerData) => {
  try {
    const response = await apiClient.post(`/api/v1/wrt-buyers/add`, {
      buyerName: buyerData.buyerName,
      clientIds: buyerData.clientIds,
    });
    return response.data.data;
  } catch (error) {
    console.error('Failed to create WRT buyer:', error);
    throw error;
  }
};

/**
 * Update WRT buyer
 */
export const updateWRTBuyer = async (id, buyerData) => {
  try {
    const response = await apiClient.patch(`/api/v1/wrt-buyers/${id}`, {
      buyerName: buyerData.buyerName,
      clientIds: buyerData.clientIds,
    });
    return response.data.data;
  } catch (error) {
    console.error('Failed to update WRT buyer:', error);
    throw error;
  }
};

/**
 * Delete WRT buyer
 */
export const deleteWRTBuyer = async (id) => {
  try {
    await apiClient.delete(`/api/v1/wrt-buyers/${id}`);
    return true;
  } catch (error) {
    console.error('Failed to delete WRT buyer:', error);
    throw error;
  }
};
